import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { rankWith, isStringControl } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import * as React from 'react';
import { useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { a as headingLower } from './typography-fe8ea2dd.js';
import { T as TextBox } from './TextBox-863d2a5a.js';
import { S as SimpleMarkdown } from './SimpleMarkdown-107c346a.js';

var _g$8;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgCalendarFlip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 4.501V25.5h25V4.501H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M10.5 4.5h5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 8,
    x: 5.5,
    y: 0.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.548 5.965a2.5 2.5 0 102.96.041l-2.96-.041zm12.005-.004a2.5 2.5 0 102.935.029l-2.935-.029z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 8,
    x: 17.5,
    y: 0.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M.5 12.5h25"
  }))));
}

var _g$7;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19
  }, props), _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797",
    "data-svg-class": "Clock-stroke"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.5 2.66V9.5m3.8 3.04L9.5 9.5"
  }))));
}

var _g$6;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgInputDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 31
  }, props), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h15v30H.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 16.5,
    r: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var _g$5;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function SvgInputEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    x: 0.5,
    y: 0.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 .607l-11.2 11.23a3.952 3.952 0 01-5.6 0L0 .607"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M18.5 10.5l9 7m-18-7l-9 7"
  }))));
}

var _g$4;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function SvgInputLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 20,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#979797",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 11.5,
    width: 19,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.5h3V7a6.5 6.5 0 10-13 0v4.5h3V7a3.5 3.5 0 017 0v4.5z"
  }))));
}

var _g$3;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgInputMailbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.414 21.313v-9.266c0-2.551 2.378-4.62 4.66-4.62 2.284 0 4.417 2.069 4.417 4.62v9.827"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.699 21.442H.579v-9.278c0-2.551 1.96-4.62 4.377-4.62h14.048"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 6.434,
    y: 0.554,
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.5 3v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M10.5 21.5v6m2-6v6"
  }))));
}

var _g$2;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgInputMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 23
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 21,
    x: 24.5,
    y: 1.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 0.5,
    y: 8.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M4.5 9.5l20-7m-20 12l20 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.058 19.55l-2.879 3.61-7.742-2.665.001-4.833"
  }))));
}

var _g$1;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgInputMobilePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 33
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 32,
    x: 0.5,
    y: 0.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M.5 3.5h17m-17 26h17"
  }))));
}

var _g;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgInputPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 31
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    x: 6.5,
    y: 0.5,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M.5 30.879v-8.445c0-2.872 2.298-4.934 4.99-4.934l13.02.121c2.692 0 4.99 2.062 4.99 4.934V31"
  }))));
}

var _path$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgInputPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 30
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9B9B9B",
    d: "M9.5 29.05a148.574 148.574 0 004.31-7.498c.53-.99 1.027-1.954 1.486-2.88 2.04-4.118 3.204-7.296 3.204-9.072 0-5.027-4.03-9.1-9-9.1s-9 4.073-9 9.1c0 1.776 1.165 4.954 3.204 9.071.459.927.956 1.89 1.487 2.881A148.574 148.574 0 009.5 29.05zm0-14.55a5 5 0 110-10 5 5 0 010 10z"
  })));
}

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgInputStandardPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.412 22.683l-2.52-1.7-2.75-1.855-4.736 1.261-.204-.251a10.809 10.809 0 01-.302-.397 23.904 23.904 0 01-2.476-4.324c-.575-1.31-.894-2.531-1.016-3.63-.067-.596-.064-1.032-.037-1.281l.027-.258 4.212-2.33a18099.685 18099.685 0 01.114-.86c.112-.831.225-1.664.333-2.442l.014-.097c.19-1.362.342-2.397.443-2.984a.808.808 0 00-.012-.278 122.73 122.73 0 01-3.213-.34L7.185.903A569.15 569.15 0 015.743.736L4.5.59l-.848-.1-.067.086A14.463 14.463 0 001.357 4.65c-1.284 3.63-1.2 7.778.823 12.446 2.029 4.68 4.833 7.847 8.047 9.755 1.994 1.184 4.25 1.805 4.655 1.702.046-.012 2.626-3.35 4.5-5.864.017-.022.025-.02.032-.013zM3.807-.287l-.034-.089c-.2-.141-.2-.141-.226-.14.12.102.203.173.26.23zM2.96-.25c.018-.025.018-.025.008-.008-.015.024-.015.024-.047.124l-.005.038A.244.244 0 012.96-.25zm-.044.154c-.02.141-.02.197.087.306a1.104 1.104 0 01-.087-.306z",
    "data-svg-class": "PhoneIcon-stroke",
    stroke: "#979797",
    fill: "none"
  })));
}

var iconToComponentMap = {
    calendar: SvgCalendarFlip,
    clock: SvgClock,
    door: SvgInputDoor,
    email: SvgInputEmail,
    lock: SvgInputLock,
    mailbox: SvgInputMailbox,
    megaphone: SvgInputMegaphone,
    person: SvgInputPerson,
    'phone-landline': SvgInputStandardPhone,
    'phone-mobile': SvgInputMobilePhone,
    pin: SvgInputPin,
};
var caOptions = {
    cleaveOptions: { blocks: [3, 3], numericOnly: false, uppercase: true },
    formatProps: {
        inputMode: 'text',
        maxLength: 7,
        pattern: '[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d',
    },
};
var initialOptions = {
    cleaveOptions: {
        blocks: [7],
        numericOnly: false,
        uppercase: true,
    },
    formatProps: {
        inputMode: 'text',
        maxLength: 7,
    },
};
var usOptions = {
    cleaveOptions: { blocks: [5], numericOnly: true },
    formatProps: {
        inputMode: 'numeric',
        maxLength: 5,
        pattern: '\\d*',
    },
};
var formatToCleaveOptionsMap = {
    phone: function () { return ({ phone: true, phoneRegionCode: 'US' }); },
    postalCode: function (data) {
        if (!data) {
            return initialOptions.cleaveOptions;
        }
        var isFirstCharacterDigit = /^\d/.test(data);
        return isFirstCharacterDigit
            ? usOptions.cleaveOptions
            : caOptions.cleaveOptions;
    },
};

var JsonFormsStringControlBase = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 0;\n  margin: 0;\n  padding: 0;\n"], ["\n  border-top: 0;\n  margin: 0;\n  padding: 0;\n"])));
var Subhead = styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  align-items: center;\n  display: flex;\n  margin: 0 0 3px;\n  text-align: left;\n\n  ", "\n"], ["\n  ", "\n\n  align-items: center;\n  display: flex;\n  margin: 0 0 3px;\n  text-align: left;\n\n  ", "\n"])), headingLower, function (_a) {
    var theme = _a.theme;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.bottomForegroundPrimary);
});
var templateObject_1, templateObject_2, templateObject_3;

var nameCounter = 0;
var jsonFormsStringControlTester = rankWith(3, isStringControl);
/**
 * String Control to be used as a renderer in the `JsonForms` component.
 *
 * @example
 *
 * <JsonForms
 *   renderers={[
 *     {
 *       renderer: JsonFormsStringControl,
 *       tester: jsonFormsStringControlTester,
 *     },
 *   ]}
 * ></JsonForms>
 */
var JsonFormsStringControl = withJsonFormsControlProps(function (_a) {
    var _b, _c, _d, _e, _f;
    var data = _a.data, enabled = _a.enabled, handleChange = _a.handleChange, label = _a.label, path = _a.path, schema = _a.schema, uischema = _a.uischema, visible = _a.visible;
    var nameRef = useRef("JsonFormsStringControl-" + ++nameCounter);
    var inputRef = useRef(null);
    var postalCodeRef = useRef(data);
    var format = (_b = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _b === void 0 ? void 0 : _b.format;
    var icon = (_c = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _c === void 0 ? void 0 : _c.icon;
    var description = (_d = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _d === void 0 ? void 0 : _d.description;
    var isMultiline = !!((_e = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _e === void 0 ? void 0 : _e.multi);
    var maxLength = schema.maxLength, title = schema.title;
    var formatProps = (function () {
        if (format === 'phone') {
            return {
                autoComplete: 'tel',
                type: 'tel',
            };
        }
        else if (format === 'postalCode') {
            if (!data) {
                return initialOptions.formatProps;
            }
            var isFirstCharacterDigit = /^\d/.test(data);
            return isFirstCharacterDigit
                ? usOptions.formatProps
                : caOptions.formatProps;
        }
    })();
    /**
     * When cleaveOptions change, the previous input HTML element is removed and
     * replace with a new one, so we need to re-focus the input element.
     */
    useEffect(function () {
        var _a;
        if (format === 'postalCode') {
            if (postalCodeRef.current !== data) {
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            postalCodeRef.current = data;
        }
    }, [format, data]);
    if (!visible) {
        return null;
    }
    return (jsxs(JsonFormsStringControlBase, { children: [title && jsx(Subhead, { children: title }, void 0), jsx(TextBox, __assign({ cleaveOptions: (_f = formatToCleaveOptionsMap[format]) === null || _f === void 0 ? void 0 : _f.call(formatToCleaveOptionsMap, data), description: description && jsx(SimpleMarkdown, { children: description }, void 0), disabled: !enabled, inputRef: inputRef, isMultiline: isMultiline, label: label, leftIcon: iconToComponentMap[icon], maxLength: maxLength, name: nameRef.current, onChange: function (event) {
                    var value = event.currentTarget.value;
                    handleChange(path, value);
                }, value: data }, formatProps), void 0)] }, void 0));
});

export { JsonFormsStringControl as J, jsonFormsStringControlTester as j };
